//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate, useParams } from 'react-router-dom'

const FilterByTeamOrDivision = (props) => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedTeams, setLoadedTeams] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [error, setError] = useState()

	const leagueId = useParams().leagueId || props.leagueId

	let selectedTeam, selectedDivision

	console.log('inside FilterByTeamOrDivision for leagueId' + leagueId)
	//
	//
	//
	//Make backend call to getTeamsInLeagueByLeagueId
	useEffect(() => {
		const getTeamsInLeague = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/allTeams/${leagueId}`
					//process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.listOfTeams)
				setLoadedDivisions(responseData.listOfDivisions)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		getTeamsInLeague()
	}, [setLoadedTeams, setLoadedDivisions])
	//
	//
	//
	//
	//
	let teamArray, divisionArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}

	if (loadedDivisions && !isLoading) {
		divisionArray = []
		loadedDivisions.forEach((div) => {
			divisionArray.push(div)
		})
	}
	//
	//
	//
	//
	//
	//

	let navigate = useNavigate()

	//For handling a search by TEAM request
	const handleChange2 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = teamArray[selectedValue]
		console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		const teamName = selectedTeam.teamName
		/* < - - navigate to TeamSchedule.js - - >*/
		navigate(`/league/schedule/${leagueName}/${teamId}/${year}/${teamName}`)
	}

	//For handling a search by DIVISION request
	const handleChange4 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedDivision = loadedDivisions[selectedValue]
		console.log('selected Division: ' + JSON.stringify(selectedDivision))
		const divisionId = selectedDivision._id
		const divisionName = selectedDivision.divisionName
		const leagueId = selectedDivision.leagueId
		navigate(`/league/${divisionName}/${leagueId}/${divisionId}/schedule`) //< - - - should go to DivisionSchedule
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Filter by Team or Division: </div>
				</div>
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange2}
								>
									<option defaultValue>- - TEAM - - </option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.divisionName + ' >>> ' + team.teamName}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
				{!isLoading && loadedDivisions && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange4}
								>
									<option defaultValue>- - DIVISION - - </option>
									{divisionArray.map((division, i) => (
										<option value={i} key={i}>
											{division.divisionName}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default FilterByTeamOrDivision
